import type { CourseOption } from './courseCatalog'

const programmes: Array<[string, string]> = [
  ['B.Tech Biotechnology', '4 Years'],
  ['B.Tech Chemical Engineering', '4 Years'],
  ['B.Tech Civil Engineering', '4 Years'],
  ['B.Tech Computer Science & Engineering', '4 Years'],
  ['B.Tech Electrical Engineering', '4 Years'],
  ['B.Tech Electronics & Communication Engineering', '4 Years'],
  ['B.Tech Information Technology', '4 Years'],
  ['B.Tech Mechanical Engineering', '4 Years'],
  ['B.Tech Production & Industrial Engineering', '4 Years'],
  ['M.Tech Applied Mechanics', '2 Years'],
  ['M.Tech Biomedical Engineering', '2 Years'],
  ['M.Tech Engineering Mechanics & Design', '2 Years'],
  ['M.Tech Fluid Engineering', '2 Years'],
  ['M.Tech Material Science & Engineering', '2 Years'],
  ['M.Tech Water Resources Management', '2 Years'],
  ['M.Tech Biotechnology', '2 Years'],
  ['M.Tech Chemical Engineering', '2 Years'],
  ['M.Tech Environmental Engineering', '2 Years'],
  ['M.Tech Geotechnical Engineering', '2 Years'],
  ['M.Tech Structural Engineering', '2 Years'],
  ['M.Tech Transportation Engineering', '2 Years'],
  ['M.Tech Computer Science & Engineering', '2 Years'],
  ['M.Tech Computer Science & Engineering (AI & Data Science)', '2 Years'],
  ['M.Tech Information Security', '2 Years'],
  ['M.Tech Control & Instrumentation', '2 Years'],
  ['M.Tech Power Electronics & Drives', '2 Years'],
  ['M.Tech Power System', '2 Years'],
  ['M.Tech Cyber Physical System', '2 Years'],
  ['M.Tech Microelectronics & VLSI Design', '2 Years'],
  ['M.Tech Communication Systems', '2 Years'],
  ['M.Tech Signal Processing', '2 Years'],
  ['M.Tech Geoinformatics', '2 Years'],
  ['M.Tech Computer Aided Design & Manufacturing (CAD/CAM)', '2 Years'],
  ['M.Tech Design Engineering', '2 Years'],
  ['M.Tech Product Design & Development', '2 Years'],
  ['M.Tech Production Engineering', '2 Years'],
  ['M.Tech Thermal Engineering', '2 Years'],
  ['M.Tech Medical Diagnostics & Devices', '2 Years'],
  ['Master of Computer Applications (MCA)', '3 Years'],
  ['Master of Business Administration (MBA)', '2 Years'],
  ['MBA — Finance', '2 Years'],
  ['MBA — Human Resources', '2 Years'],
  ['MBA — Marketing', '2 Years'],
  ['MBA — Operations', '2 Years'],
  ['M.Sc. Mathematics & Scientific Computing', '2 Years'],
  ['Master of Social Work (MSW)', '2 Years'],
  ['Ph.D. — Engineering', '3+ Years'],
  ['Ph.D. — Science', '3+ Years'],
  ['Ph.D. — Management', '3+ Years'],
  ['Ph.D. — Humanities / Social Sciences', '3+ Years'],
  ['M.Tech Part-Time — Structural Engineering', '3 Years'],
  ['M.Tech Part-Time — Geotechnical Engineering', '3 Years'],
  ['M.Tech Part-Time — Environmental Engineering', '3 Years'],
  ['M.Tech Part-Time — Software Engineering', '3 Years'],
  ['M.Tech Part-Time — Power Electronics & ASIC Design', '3 Years'],
  ['M.Tech Part-Time — Control & Instrumentation', '3 Years'],
  ['M.Tech Part-Time — Digital Systems', '3 Years'],
  ['M.Tech Part-Time — Production Engineering', '3 Years'],
  ['M.Tech Part-Time — CAD/CAM', '3 Years'],
  ['MBA Part-Time', '3 Years'],
]

export const MNNIT_COURSE_CATALOG: CourseOption[] = programmes.map(([name, durationYears]) => ({ name, durationYears }))